// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/style/framework.scss'; //修改的框架UI样式
import '@/assets/style/common.scss'; //通用全局样式
import _ from 'lodash';
import echarts from 'echarts';
import $ from 'jquery';
import ajax from '@/model/ajax.js'
// import EmAxios from '@/model/axios.js'
import VueDND from 'awe-dnd';
import vuedraggable from 'vuedraggable';
import axios from 'axios'
import 'babel-polyfill'
import VueAxios from 'vue-axios'
Vue.use(VueAxios,axios);
Vue.use(VueDND)

Vue.prototype.ajax = ajax
// Vue.prototype.$axios = EmAxios

Vue.config.productionTip = false
Vue.use(ElementUI);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js